/**
 * Which KBV Stammdatei a catalog release was imported from.
 *
 * - `sdhm`  — Heilmittelkatalog (Kapitel → Diagnosegruppen with allowed
 *   Heilmittel, Mengen, Frequenzen, ICD gates).
 * - `sdhma` — Diagnoseliste für langfristigen Heilmittelbedarf / besondere
 *   Verordnungsbedarfe (BVB/LHM).
 * - `icd10gm` — the BfArM's ICD-10-GM (one release per Version, valid from 1
 *   January), the Systematik behind every diagnosis code a Verordnung carries.
 */
export var CatalogReleaseKind;
(function (CatalogReleaseKind) {
    CatalogReleaseKind["SDHM"] = "sdhm";
    CatalogReleaseKind["SDHMA"] = "sdhma";
    CatalogReleaseKind["ICD10GM"] = "icd10gm";
})(CatalogReleaseKind || (CatalogReleaseKind = {}));
//# sourceMappingURL=catalog-release-kind.enum.js.map